import { queryOptions, keepPreviousData } from '@tanstack/react-query';
import { z } from 'zod';
import { withPaginationSchema, parseSearchParams } from '@/api/utils';
import { PaginationParams } from '@/api/types';
import api from '../api';
import { Site, SiteSchema } from '@/api/schema/site';
import { User, UserSchema } from '@/api/schema/user';

export type { Site, User };

export type SitesParams = {
  name?: string;
  city?: string;
  [key: string]: string | number | boolean | undefined;
} & PaginationParams;

function parseParams(params: SitesParams) {
  return parseSearchParams(params);
}

export function getSitesQueryOptions(params?: SitesParams) {
  return queryOptions({
    queryKey: [ 'sites', params ],
    queryFn: async () => {
      if (!params) throw new Error('Params are required');

      const response = await api.get('sites', {
        searchParams: parseParams(params),
      });
      return withPaginationSchema(SiteSchema).parse(await response.json());
    },
    placeholderData: keepPreviousData,
  });
}

export function getSiteQueryOptions(id: string) {
  return queryOptions({
    queryKey: [ 'sites', id ],
    queryFn: async () => {
      const response = await api.get(`sites/${id}`);
      return SiteSchema.parse(await response.json());
    },
  });
}

export function getSiteUsersQueryOptions(siteId: string) {
  return queryOptions({
    queryKey: [ 'sites', siteId, 'users' ],
    queryFn: async () => {
      const response = await api.get(`sites/${siteId}/users`);
      return z.array(UserSchema).parse(await response.json());
    },
  });
}
